import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { TimesheetModel } from '../../../../reducers/orm/timesheet/timesheet.model';

interface TimesheetStatus {
  timesheet: TimesheetModel;
  status: string;
}

@Injectable()
export class TimesheetDayService {
  // The totals and rows need to be able to send status updates to each other.
  status$ = new Subject<TimesheetStatus>();
}
